var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0069 5.31892C12.2542 5.07159 12.6552 5.07159 12.9026 5.31892L17.9692 10.3856C18.2166 10.6329 18.2166 11.0339 17.9692 11.2813L12.9026 16.3479C12.6552 16.5953 12.2542 16.5953 12.0069 16.3479C11.7596 16.1006 11.7596 15.6996 12.0069 15.4523L15.9924 11.4668H4.01029C3.66051 11.4668 3.37695 11.1832 3.37695 10.8334C3.37695 10.4836 3.66051 10.2001 4.01029 10.2001H15.9924L12.0069 6.21459C11.7596 5.96726 11.7596 5.56625 12.0069 5.31892Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.422222
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.3be6a0f7ba68beee91144c7319b633cf.svg";
export { ForwardRef as ReactComponent };